/* eslint-disable max-lines-per-function */

import { commonTranslationKeys } from '@dreryk/react-common';
import {
   ButtonVariant,
   Modal,
   ModalCancelButton,
   ModalCloseButton,
   ModalConfirmButton,
   ModalWidth,
} from '@dreryk/react-components';

import { VisitSettlementForm, VisitSettlementFormInitializer } from '../shared/form/VisitSettlementForm';
import { visitSettlementTranslationKeys } from '../translations';

import { VisitSettlementAdjustAction } from './VisitSettlementAdjustmentModal.actions';

const t = visitSettlementTranslationKeys.adjustmentModal;

type VisitSettlementAdjustmentModalProps = {
   readonly appointmentId: number;
   readonly practitionerId: number;
   readonly onCancel: VoidFunction;
   readonly onSuccess: VoidFunction;
   readonly initializer: VisitSettlementFormInitializer;
};

export const VisitSettlementAdjustmentModal = (props: VisitSettlementAdjustmentModalProps): JSX.Element => {
   return (
      <Modal testId={'visitSettlementAdjustment'} title={t.title} width={ModalWidth.NORMAL}>
         <VisitSettlementForm
            appointmentId={props.appointmentId}
            practitionerId={props.practitionerId}
            initializer={props.initializer}
         >
            {({ handleSubmit, formState }) => (
               <>
                  <VisitSettlementAdjustAction appointmentId={props.appointmentId} onSuccess={props.onSuccess}>
                     {({ adjust }) => (
                        <ModalConfirmButton
                           label={commonTranslationKeys.save}
                           onClick={handleSubmit(adjust)}
                           variant={ButtonVariant.PRIMARY}
                        />
                     )}
                  </VisitSettlementAdjustAction>

                  <ModalCancelButton
                     label={commonTranslationKeys.cancel}
                     onClick={props.onCancel}
                     shouldConfirmExit={formState.isDirty}
                  />
                  <ModalCloseButton onClick={props.onCancel} shouldConfirmExit={formState.isDirty} />
               </>
            )}
         </VisitSettlementForm>
      </Modal>
   );
};
